
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.428 11.674C19.068 10.484 20 8.767 20 6.917c0-3.447-3.27-6.25-7.292-6.25-3.245 0-6.05 1.789-6.981 4.451a.416.416 0 10.786.275C7.315 3.101 9.863 1.5 12.708 1.5c3.561 0 6.459 2.43 6.459 5.417 0 1.676-.912 3.233-2.501 4.271a.417.417 0 00-.145.535l.407.816-1.179-.674a.422.422 0 00-.357-.028c-.57.22-1.187.37-1.83.443a.417.417 0 00.094.827 8.28 8.28 0 001.848-.422l2.205 1.26a.417.417 0 00.58-.548l-.86-1.723z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.25 6.499c-3.447 0-6.25 2.243-6.25 5 0 1.486.84 2.902 2.263 3.847l-.567 1.416a.417.417 0 00.574.527l2.066-1.033c.627.161 1.27.243 1.914.243 3.447 0 6.25-2.242 6.25-5 0-2.757-2.803-5-6.25-5zm-.002 9.168a6.826 6.826 0 01-1.846-.255.418.418 0 00-.299.028l-1.227.613.289-.722a.416.416 0 00-.177-.514c-1.37-.8-2.155-2.009-2.155-3.317 0-2.298 2.43-4.167 5.416-4.167 2.987 0 5.416 1.87 5.416 4.167 0 2.297-2.43 4.166-5.417 4.166z","fill":"#fff"}})])
          )
        }
      }
    